const germanToEnglish: Record<string, string> = {
    'mech. Konstruktion': 'Mechanical Constructor',
    Robotik: 'Robotics',
    Hardwarekonstruktion: 'Hardware Constructor',
    Softwarekonstruktion: 'Software Developer',
    'SW Konstruktion/IBN': 'Software Developer / IBN',
    Inbetriebnahme: 'Commissioning Engineer',
    Projektleitung: 'Project Manager',
    Installation: 'Installation Technician',
    IT: 'IT',
    Anlage: 'Facility',
    SPS: 'PLC',
    Station: 'Station',
    Robot: 'Robot',
    Gripper: 'Gripper',
};

// string 1 = LDAP
// string 2 = InFlow(departments and features)

const ldapToInFlowFeatures: Record<string, string> = {
    'mech. Konstruktion': 'mech. Konstruktion',
    Robotics: 'Robotik',
    Hardwarekonstruktion: 'Hardwarekonstruktion',
    HW: 'HW-Konstruktion',
    Softwarekonstruktion: 'SW-Konstruktion',
    'SW Konstruktion/IBN': 'SW Konstruktion/IBN',
    Inbetriebnahme: 'IBN',
    Installation: 'Installation',
    IT: 'IT',
};

export const mappingGermanToEnglish = (name: string): string => {
    return germanToEnglish[name] || name;
};

export const mappingLdapToInFlowFeatures = (name: string): string => {
    return ldapToInFlowFeatures[name] || name;
};
